"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._VersioningConfiguration = {
    type: "structure",
    required: [],
    members: {
        MFADelete: {
            shape: {
                type: "string"
            },
            locationName: "MfaDelete"
        },
        Status: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_VersioningConfiguration.js.map